<template>
  <div>
    <header class="top-bar">
      <div class="left">
        <div class="toggle-sidebar" v-on:click="toggleSidebar">
          <i class="material-icons">menu</i>
        </div>
        <div class="search-section">
          <input
            type="text"
            v-model="search"
            v-on:click="clearSearchInput"
            :class="{ 'search-active': searchActive }"
            v-on:blur="restoreInput"
            class="search-field"
          />
          <div class="loader" v-show="searching">Loading...</div>
          <div class="search-results" v-if="searchResults.length">
            <div
              class="result"
              v-bind:key="index"
              v-for="(result, index) in searchResults"
              v-on:click="goToIncident(result)"
            >
              <strong>{{ result.source.claim_reference }}</strong>
            </div>
          </div>
          <div
            class="search-results"
            v-if="
              !searchResults.length &&
                search != 'Search...' &&
                search &&
                !searching
            "
          >
            <div class="result"><strong>No Results Found</strong></div>
          </div>
        </div>
      </div>
      <div class="right">
        <!--<div class="tasks flexible">-->
        <!--<i class="material-icons">view_list</i>-->
        <!--</div>-->
        <div class="notifications flexible" v-on:click="toggleNotifications">
          <span class="icon-count" v-text="notificationsCount"></span>
          <i class="material-icons">notifications</i>
        </div>
        <div
          class="more flexible ignore-clickaway"
          :class="{ open: dropdown }"
          v-on:click="toggleDropdown"
        >
          <i class="material-icons ignore-clickaway">more_vert</i>
        </div>
      </div>
    </header>
    <div
      class="dropdown-menu-list"
      :class="{ open: dropdown }"
      v-on-clickaway="clickedAwayFromDropDown"
    >
      <ul>
        <li><a href="#" v-on:click.prevent="logout">Logout</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import throttle from 'lodash/throttle';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [clickaway],

  data() {
    return {
      search: 'Search...',
      dropdown: false,
      searchResults: [],
      searchActive: false,
      searching: false
    };
  },

  computed: {
    notificationsCount() {
      return this.$store.getters['Notifications/count'];
    }
  },

  methods: {
    goToIncident(result) {
      this.search = 'Search...';
      this.searchResults = [];
      this.$router.push(`/first-notice-of-loss/${result.identifier}`);
    },

    restoreInput() {
      if (!this.search) {
        this.search = 'Search...';
        this.searchResults = [];
        this.searchActive = false;
      }
    },

    clearSearchInput() {
      if (this.search === 'Search...') {
        this.search = null;
        this.searchActive = true;
      }
    },

    logout() {
      window.Token.forget();
      this.$store.commit('setUser', {});
      this.$router.push('/login');
    },

    clickedAwayFromDropDown(event) {
      if (
        this.dropdown &&
        !event.target.classList.contains('ignore-clickaway')
      ) {
        this.dropdown = false;
      }
    },

    toggleDropdown() {
      this.dropdown = !this.dropdown;
    },

    toggleNotifications() {
      this.$store.commit('Notifications/toggle');
    },

    toggleSidebar() {
      this.$emit('toggled');
    }
  },

  watch: {
    search: {
      handler: throttle(function(value) {
        if (value) {
          this.searching = true;

          window.Ajax.get(`/incidents/search?q=${value}`, false)
            .then(response => {
              let results = response.data;

              if (results.length) {
                this.searchResults = results;
              } else {
                this.searchResults = [];
              }

              this.searching = false;
            })
            .catch(error => {});
        }
      }, 1000),
      deep: true
    }
  }
};
</script>
